import React from "react";
import { Box, Divider, Typography } from "@material-ui/core";
import TranslatedMaterialTable from "../../../shared/TranslatedMaterialTable";
import useRequest from "../../../utils/hook/requestHook";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { Pass } from "../../../models/Pass";
import { get } from "../../../api";
import { GET_PASSES_BY_WEB_LOGIN } from "../../../api/apiRoutes";
import getId from "../../../utils/getId";
import { format } from "date-fns";

const columns = [
  {
    title: "Nazwa biletu",
    field: "name",
  },
  {
    title: "Szczegóły",
    field: "validfrom",
    render: (row: Pass) => (
      <React.Fragment>
        <Box>{`${format(row.validfrom, "dd-MM-yyyy")}`}</Box>

        {row.exercises.length > 0 && (
          <React.Fragment>
            {row.exercises.map((item, index) => (
              <React.Fragment key={index}>
                <Typography>{`${format(item.startTime, "HH:mm")} - ${format(item.closeTime, "HH:mm")}`}</Typography>
                <Typography>{item.zone.displayName}</Typography>
                <Typography>{item.name}</Typography>
                {row.exercises.length > 1 && <Divider />}
              </React.Fragment>
            ))}
          </React.Fragment>
        )}
      </React.Fragment>
    ),
  },
  {
    title: "Status",
    field: "status",
    render: (row: Pass) => `${getStatusName(row.status)}`,
  },
  { title: "Ilość wejść", field: "entrances" },
];

const getStatusName = (value: string | undefined) => {
  switch (value) {
    case "A":
      return "Aktywny";
    case "U":
      return "Wykorzystany";
    case "I":
      return "Nieaktywny";
    default:
      return "Nieznany status";
  }
};

const CarnetTableTab: React.FC = () => {
  const webUser = useSelector((state: State) => state.auth.webUser);
  const [data, loading] = useRequest<Pass[]>(async () => await get(GET_PASSES_BY_WEB_LOGIN(getId(webUser))));
  return (
    <Box my={3} style={{ width: "100%" }}>
      <TranslatedMaterialTable
        onRowClick={() => {}}
        title={``}
        isLoading={loading}
        columns={columns}
        data={data ? data : []}
      />
    </Box>
  );
};

export default CarnetTableTab;
